






















































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import axios from 'axios'
import moment from 'moment'
import api from '@/api'
import Page from '@/components/Page/index.vue'
import Pagination from '@/components/Pagination/index.vue'
import config from '@/config'
import Status from '@/utils/Status'
import StatusFlash from '@/components/StatusFlash/index.vue'
import { stateClass } from '@/utils/fdpIndex'

@Component({ components: { Page, Pagination, StatusFlash } })
export default class Index extends Vue {
  data: any = null

  info: any = null

  filter: string = 'ACTIVE'

  permitFilter: string = 'ACCEPTED'

  sort: string = 'updatedAt,desc'

  page: number = 1

  status: Status = new Status()

  actionStatus: Status = new Status()

  states: string[] = ['ALL', 'ACTIVE', 'INACTIVE', 'UNREACHABLE', 'INVALID', 'UNKNOWN']

  permits: string[] = ['ALL', 'ACCEPTED', 'REJECTED', 'PENDING']

  get user() {
    return this.$store.getters['auth/user']
  }

  get isAdmin() {
    return _.get(this.user, 'role') === 'ADMIN'
  }

  created(): void {
    this.init()
  }

  async filterData(filter: string) {
    this.filter = filter
    this.page = 0
    this.updateUrl()

    await this.loadFdps()
  }

  async filterPermit(permitFilter: string) {
    this.permitFilter = permitFilter
    this.page = 0
    this.updateUrl()

    await this.loadFdps()
  }

  async sortData(sort: string) {
    this.sort = sort
    this.page = 0
    this.updateUrl()

    await this.loadFdps()
  }

  updateUrl(): void {
    window.history.pushState(null, '', this.createUrl())
  }

  createUrl(page = null): string {
    const pageNumber = page || this.page
    const permitFilter = this.isAdmin ? `&permit=${this.permitFilter}` : ''
    return `/?state=${this.filter}${permitFilter}&sort=${this.sort}&page=${pageNumber}`
  }

  formatDateTime(value): string {
    return moment(value).format(config.dateTimeFormat)
  }

  stateToReadable(state) {
    return _.startCase(_.toLower(state))
  }

  badgeClass(state) {
    return stateClass(state)
  }

  openPage(page) {
    const url = this.createUrl(page + 1)
    this.$router.push(url)
  }

  @Watch('$route')
  async init() {
    this.filter = _.get(this.$route.query, 'state', this.filter) as string
    this.sort = _.get(this.$route.query, 'sort', this.sort) as string
    this.page = parseInt(_.get(this.$route.query, 'page', this.page) as string, 10)

    try {
      this.status.setPending()
      const infoResponse = await api.fdpIndex.getInfo()
      this.info = infoResponse.data
      await this.loadFdps()
    } catch (error) {
      this.status.setError('Unable to get FAIR Data Points.')
    }
  }

  async loadFdps() {
    try {
      this.actionStatus.setDone()

      this.status.setPending()
      this.data = null

      const dataResponse = await api.fdpIndex.getEntries({
        state: this.filter,
        permit: this.permitFilter,
        sort: this.sort,
        page: this.page,
      })

      this.data = dataResponse.data

      this.status.setDone()
    } catch (error) {
      this.status.setError('Unable to get FAIR Data Points.')
    }
  }

  async syncFdp(entry) {
    try {
      this.actionStatus.setPending()
      await api.fdpIndex.ping(entry.clientUrl)
      await this.init()
      this.actionStatus.setDone(`Syncing of "${entry.clientUrl}" started!`)
    } catch (error) {
      this.actionStatus.setError(`Unable to sync "${entry.clientUrl}"`)
    }
  }

  async removeFdp(entry) {
    if (window.confirm(`Are you sure you want to remove "${entry.clientUrl}"?`)) {
      try {
        this.actionStatus.setPending()
        await api.fdpIndex.deleteEntry(entry.uuid)
        await this.init()
        this.actionStatus.setDone(`Successfully removed "${entry.clientUrl}"`)
      } catch (error) {
        this.actionStatus.setError(`Unable to remove "${entry.clientUrl}"`)
      }
    }
  }
}
